import React from 'react';

import { PropertyDetail } from 'components/blocks/Property';

const DetailScreen = (props) => {
  return (
    <div className="page-main">
      <PropertyDetail />
    </div>
  );
};

export default DetailScreen;
